import { useEffect } from "react";
import { useRef } from "react";
import { setupClient} from "./utils/Networking.js";
import { sendAimAngle, sendAimAngleAndShoot} from "./utils/Networking.js";

import "./scss/main.scss";
import "./scss/style.css";

export let setColorCallback;
export let setStringCallback;
export let setIntCallback;
export let setInt2Callback;

function App() {

    const elementsRef = useRef({
        canvas: null,
        objContainer: null,
        context: null,
        nameTitle: null,
        score: null,
        visual:null
    });

    const valuesRef = useRef({
        width:0,
        height:0,
        x:0,
        y:0,
        prevX:0,
        prevY:0,
        pressed:false,
        minSize:0,
        internalRadius:0,
        externalRadiu:0,
        centerX:0,
        centerY:0,
        lastVector:"",
        colorJoy : "#FFFFFF",
        playerName : "",
        commandsFrequency: 10,
        indexTexture:0
    });

    const elems = elementsRef.current;
    const values = valuesRef.current;


  useEffect(() => {
    document.title = "BADABEAM - BADAGOLF Controller";

    // var serverAddress = process.env.SERVER_ADDRESS || `ws://${window.location.hostname}:3001`; // "ws://localhost:3001"

    // if (process.env.NODE_ENV && process.env.NODE_ENV !== 'development')
    //     serverAddress = `wss://${window.location.hostname}`;

    var serverAddress = `wss://${window.location.hostname}`;

    elems.visual = new Image();
    elems.visual.onload = GoDrawJoystick;
    elems.visual.src = "./texture_3.png";

    elems.canvas = document.createElement("canvas");
    elems.canvas.id = "canvasJoy";

    elems.objContainer = document.getElementById("joyDiv");
    elems.objContainer.style.touchAction = "none";
    elems.objContainer.appendChild(elems.canvas);

    elems.context = elems.canvas.getContext("2d");

    elems.score = document.getElementById("score");
    elems.nameTitle = document.getElementById("name");
    
    window.onload = function () 
    {
        document.body.addEventListener("touchstart", function () {}, false);

        if ("ontouchstart" in document.documentElement) 
        {
            elems.canvas.addEventListener("touchstart", onTouchStart, false);
            document.addEventListener("touchmove", onTouchMove, false);
            document.addEventListener("touchend", onTouchEnd, false);
            document.addEventListener("touchcancel", onTouchCancel, false);
        } 
        else 
        {
            elems.canvas.addEventListener("mousedown", onTouchStart, false);
            document.addEventListener("mousemove", onTouchMove, false);
            document.addEventListener("mouseup", onTouchEnd, false);
            document.addEventListener("mousecancel", onTouchCancel, false);
        }

        window.onresize = function () {Reset();};
        window.onorientationchange = function () {Reset();};
        window.setInterval(SendLastVector,1000/values.commandsFrequency);
        Reset();
    };

    function onTouchStart(event) {onStart(event);}
    function onTouchMove(event) {onMove(event);}
    function onTouchCancel(event) {onEnd();}
    function onTouchEnd(event) {onEnd();}

    function onStart(event)
    {
        values.pressed = true;
        onMove(event);
    }

    function onMove(event) 
	{
        if (!values.pressed)
            return;

        var posJoystickX = -values.centerX;
        var posJoystickY = -values.centerY;


        if (event.targetTouches === undefined) 
        {
            posJoystickX += event.pageX;
            posJoystickY += event.pageY;
        } 
        else if (event.targetTouches[0].target === elems.canvas)
        {
            posJoystickX += event.targetTouches[0].pageX;
            posJoystickY += event.targetTouches[0].pageY;
        } 
        else 
            return;

        var m = Math.sqrt(posJoystickX * posJoystickX + posJoystickY * posJoystickY);

        if (m > (values.externalRadius*0.75))
        {
            posJoystickX *= (values.externalRadius*0.75) / m;
            posJoystickY *= (values.externalRadius*0.75) / m;
        }

        DrawJoystick(values.centerX + posJoystickX, values.centerY + posJoystickY);

        values.x = (50 * posJoystickX / (values.externalRadius*0.75)).toFixed();
        values.y = (-50 * posJoystickY / (values.externalRadius*0.75)).toFixed();

        if (values.x != values.prevX || values.y != values.prevY)
	    {
            values.prevX = values.x;
            values.prevY = values.y;
            values.lastVector = values.x + "," + values.y;
	    }
    }

    function GoDrawJoystick()
    {
        DrawJoystick(values.centerX, values.centerY);
    }

    function DrawJoystick(posX,posY) 
    {
        elems.context.clearRect(0, 0, elems.canvas.width, elems.canvas.height);

        elems.context.translate(posX, posY);

        elems.context.drawImage(elems.visual, -values.externalRadius, -values.externalRadius, values.externalRadius * 2, values.externalRadius * 2)

        elems.context.globalCompositeOperation = "multiply";
        
        elems.context.fillStyle = values.colorJoy;
        elems.context.fillRect(- values.externalRadius * 2, - values.externalRadius * 2, values.externalRadius * 4, values.externalRadius * 4);
        elems.context.globalCompositeOperation = "source-over";


        elems.context.globalCompositeOperation = "destination-in";
        elems.context.drawImage(elems.visual, -values.externalRadius, -values.externalRadius, values.externalRadius * 2, values.externalRadius * 2)
      
        elems.context.globalCompositeOperation = "source-over";

        elems.context.setTransform(1, 0, 0, 1, 0, 0);

        elems.context.beginPath();
        elems.context.arc(values.centerX, values.centerY, values.externalRadius, 0, 2 * Math.PI, false);
        elems.context.lineWidth = 2;
        elems.context.strokeStyle = values.colorJoy;
        elems.context.stroke();

        elems.context.font = "80px myFont";
        elems.context.fillStyle = "#000000";
        elems.context.textAlign = "center";

        elems.context.lineWidth = 7;
        elems.context.strokeStyle = values.colorJoy;
        elems.context.strokeText(values.playerName, posX, posY + 14);

        elems.context.font = "80px myFont";
        elems.context.fillStyle = "#000000";
        elems.context.textAlign = "center";

        elems.context.fillText(values.playerName, posX, posY + 14);

    }

    function onEnd() 
    {
        SendLastVectorAndShoot();
        values.pressed = false;
        DrawJoystick(values.centerX, values.centerY);
        values.x = 0;
        values.y = 0;
        values.prevX = 0;
        values.prevY = 0;
    }

    function Reset() 
    {
        values.width = elems.objContainer.clientWidth;
        values.height = elems.objContainer.clientHeight;
        elems.canvas.width = values.width;
        elems.canvas.height = values.height;
        values.centerX = elems.canvas.width / 2;
        values.centerY = elems.canvas.height / 2;

        values.minSize = elems.canvas.width < elems.canvas.height ? elems.canvas.width : elems.canvas.height;
        values.internalRadius = (values.minSize - (values.minSize / 2 + 10)) / 2;
        values.externalRadius = values.internalRadius + 30;

        values.x = 0;
        values.y = 0;
        values.prevX = 0;
        values.prevY = 0;
        values.lastVector ="";

        DrawJoystick(values.centerX, values.centerY);

        values.pressed = false;
    }

    function SendLastVector()
    {
        if (values.commandsFrequency<1)
            return;

        if (values.lastVector)
        {
            sendAimAngle([values.x, values.y]);
            values.lastVector="";
        }     
    }

    function SendLastVectorAndShoot()
    {
        sendAimAngleAndShoot([values.x, values.y]);
    }

    setColorCallback = (colorData) => 
    {
        values.colorJoy = colorData.includes("#") ? colorData : `#${colorData}`;
        DrawJoystick(values.centerX, values.centerY);
    };

    setStringCallback = (stringData) => 
    {
        elems.nameTitle.textContent = "";
        values.playerName = stringData;
        DrawJoystick(values.centerX, values.centerY);
    };

    setIntCallback = (intData) => 
    {
        elems.score.innerHTML = "<div style='color:" + values.colorJoy + "'>SCORE: " + intData + "</div>";
    };

      setInt2Callback = (int2Data) => {
          console.log(int2Data);
          values.indexTexture = int2Data;
          elems.visual.src = "./texture_" + values.indexTexture + ".png";
          GoDrawJoystick();
    };

    setupClient(serverAddress);
  }, []);

  return (
    <div id="container">
      <div id="joyDiv"></div>
      <div id="name">REFRESH PAGE</div>
      <div id="score">SCORE: 0</div>
    </div>
  );
}

export default App;